import type {
  BranchEventParams,
  BranchParams as NativeBranchParams,
} from 'react-native-branch'

/**
 * Web stub for Branch SDK.
 * Branch web SDK integration is handled via the marketing site (vocalise.app).
 * This stub prevents import errors when the app runs on web.
 */
export type BranchParams = NativeBranchParams

export interface BranchOpenResult {
  params: BranchParams | null
  clickedBranchLink: boolean
  nonBranchLink: boolean
  cachedInitialEvent: boolean
}

export async function initBranch(): Promise<void> {
  // Branch web SDK is not loaded in the app SPA build.
}

export function subscribeToBranchLinks(
  _onParams?: (params: BranchParams) => void,
): () => void {
  return () => {}
}

export async function awaitInitialBranchOpen(): Promise<BranchOpenResult> {
  return {
    params: null,
    clickedBranchLink: false,
    nonBranchLink: false,
    cachedInitialEvent: false,
  }
}

export function logBranchEvent(
  _eventName: string,
  _metadata?: BranchEventParams,
): void {
  // No-op on web
}
